export const PENDING = "PENDING";
export const APPROVED = "APPROVED";
export const INCOMPLETE = "INCOMPLETE";
export const SUSPENDED = "SUSPENDED";
export const ALL = "ALL";
